import React, { useState } from 'react'

import { Image, Accordion } from 'react-bootstrap'

import FavoriteIcon from '../icons/FavoriteIcon'
import styles from './../style/ProductCard.module.scss'
import ClientOnlyFsLightbox from './../block/ClientOnlyFsLightbox'

const ProductCard = ({ options, ajax_data, changeFavorite, favorite, link_optproducts }) => {
  const [show_feedback, set_feedback] = useState(false)
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1
  })

  const isFavorite = favorite.includes( ajax_data.id )

  const openLightbox = (slideNumber) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: slideNumber
    })
  }

  return (
    <div className={styles.productContainer}>
      {/* Lightbox компонент */}
      <ClientOnlyFsLightbox
        toggler={lightboxController.toggler}
        sources={ajax_data.images.map(img => img.image)}
        slide={lightboxController.slide}
      />

      <div className={styles.cardsRow2}>
        <div className={styles.card3}>
          <div className={styles.cardContent}>
            <div className={styles.fourColumnLayout}>
              {ajax_data.images.length > 0 &&
                <div className={styles.photoColumn}>
                  <div 
                    className={styles.mainPhoto}
                    style={{cursor: 'pointer'}}
                  >
                    <img 
                      onClick={() => openLightbox(1)} 
                      src={ajax_data.images[0].image_thumb} 
                      alt="Main product" 
                      loading="lazy"
                    />
                  </div>
                  {ajax_data.images.length > 1 &&
                    <div className={styles.thumbnails}>
                      {ajax_data.images.slice(1, 5).map((img, index) => (
                        <div
                          key={index}
                          onClick={() => openLightbox(index + 2)}
                          className={styles.thumbnail}
                          style={{cursor: 'pointer'}}
                        >
                          <img 
                            src={img.image_small} 
                            alt={`Галерея ${index + 1}`} 
                            loading="lazy"
                          />
                        </div>
                      ))}
                    </div>
                  }
                  <div className={styles.photoColumnText + ` d-md-none`}>*Внешний вид товара может отличаться от фотографии</div>
                </div>
              }

              <div className={styles.manufacturerColumn}>

                <div 
                  className={styles.articleContainer}
                  onClick={() => {
                    navigator.clipboard.writeText(ajax_data?.article || '')
                      .then(() => {
                        console.log('Артикул скопирован в буфер обмена');
                      })
                      .catch(err => {
                        console.error('Не удалось скопировать артикул: ', err);
                      });
                  }}
                  style={{cursor: 'pointer'}}
                >
                  <span>Арт {ajax_data?.article || ''}</span>
                  <svg className={styles.articleIcon} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.62 1H5.673C4.791 1 4.092 1 3.5455 1.074C2.9825 1.15 2.527 1.31 2.168 1.6705C1.8085 2.031 1.649 2.4885 1.5735 3.0535C1.5 3.6025 1.5 4.304 1.5 5.1895V8.1085C1.5 8.8625 1.96 9.5085 2.6135 9.7795C2.58 9.3245 2.58 8.687 2.58 8.156V5.651C2.58 5.0105 2.58 4.458 2.639 4.016C2.7025 3.542 2.8455 3.088 3.2125 2.7195C3.5795 2.351 4.032 2.2075 4.504 2.1435C4.944 2.0845 5.494 2.0845 6.1325 2.0845H7.6675C8.3055 2.0845 8.8545 2.0845 9.295 2.1435C9.16305 1.80665 8.93266 1.51737 8.63388 1.31339C8.33509 1.10941 7.98177 1.0002 7.62 1Z" fill="#3D3D3D" fill-opacity="0.8"/>
                    <path d="M3.2998 5.69814C3.2998 4.33514 3.2998 3.65364 3.7218 3.23014C4.1433 2.80664 4.8218 2.80664 6.1798 2.80664H7.6198C8.9773 2.80664 9.6563 2.80664 10.0783 3.23014C10.5003 3.65364 10.4998 4.33514 10.4998 5.69814V8.10814C10.4998 9.47114 10.4998 10.1526 10.0783 10.5761C9.6563 10.9996 8.9773 10.9996 7.6198 10.9996H6.1798C4.8223 10.9996 4.1433 10.9996 3.7218 10.5761C3.2998 10.1526 3.2998 9.47114 3.2998 8.10814V5.69814Z" fill="#3D3D3D" fill-opacity="0.8"/>
                  </svg>
                </div>

                <div className="d-flex align-items-center justify-content-between">
                  <h1 className={styles.productTitle}>
                    {ajax_data?.pagetitle || ''}{ajax_data?.longtitle != `` ? `, ${ajax_data?.longtitle}.` : ``}
                  </h1>
                </div>

                <div className={styles.manufacturerColumnLegalOpts}>
                  <div>
                    <div className={styles.manufacturerLabel}>Производитель</div>
                    <div className={styles.manufacturerValue}>{ajax_data?.vendor || ' - '}</div>
                  </div>
                  <div>
                    <div className={styles.volumeLabel}>Объём</div>
                    <div className={styles.volumeValue}>{ajax_data.options?.volume || ' - '}</div>
                  </div>
                  <div>
                    <div className={styles.manufacturerLabel}>Тип упаковки</div>
                    <div className={styles.manufacturerValue}>{ajax_data.options?.typeofpackaging || ' - '}</div>
                  </div>
                  <div>
                    <div className={styles.volumeLabel}>Срок годности</div>
                    <div className={styles.volumeValue}>{ajax_data.options?.expirationdate || ' - '}</div>
                  </div>
                </div>
                <div className={styles.imageNote2}>*Внешний вид товара может отличаться от фотографии</div>
              </div>

            </div>
          </div>
        </div>

        <div className={styles.card4}>
          <div className={styles.card2Content}>

            <div className={styles.actionButtons}>
              <a href={link_optproducts} className={styles.addToCartButton}>
                Оформить заказ в личном кабинете
              </a>
            </div>

            <div className={styles.contactInfo}>
              <span>Возникли вопросы? Свяжитесь с нами в Telegram, WhatsApp или по телефону</span>
              <div className={styles.contactIcons}>
                {'tglink' in options &&
                  <a href={options.tglink} target="_blank" rel="noopener noreferrer">
                    <Image alt="TG" src={options?.tgicon || ''} width="35" height="35" />
                  </a>
                }
                {'walink' in options &&
                  <a href={options.walink} target="_blank" rel="noopener noreferrer">
                    <Image alt="WA" src={options?.waicon || ''} width="35" height="35" />
                  </a>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardsRow2}>
        <Accordion defaultActiveKey="0" className={styles.faqAccordion}>
          {ajax_data?.accordion.map((item, index) => (
            <Accordion.Item key={index} eventKey={index.toString()} className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionHeader}>
                <span className={styles.accordionTitle}>{item.name}</span>
              </Accordion.Header>
              <Accordion.Body className={styles.accordionBody} dangerouslySetInnerHTML={{__html: item.text}} />
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  )
}

export default ProductCard;